import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[autofocus]',
})
export class AutofocusDirective implements AfterViewInit {
  private _autofocus = true;

  @Input() set autofocus(condition: boolean) {
    this._autofocus = condition !== false;
  }

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    if (this._autofocus) {
      this.setFocus();
    }
  }

  private setFocus(): void {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    setTimeout(() => {
      const element = this.el.nativeElement;
      element.focus();
      if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
        const input = element as HTMLInputElement | HTMLTextAreaElement;
        const length = input.value?.length || 0;
        input.setSelectionRange(length, length);
      }
    });
  }
}
